import React from 'react'
import { useSelector } from 'react-redux'
import { t } from 'ttag'

import { AuthButton } from 'components/auth/common/AuthButton/AuthButton'
import { Form } from 'components/shared/Form/Form'
import { Link } from 'components/shared/Link/Link'
import { MessageAlert } from 'components/shared/Alerts/MessageAlert/MessageAlert'

import { getUser } from 'ducks/auth'
import { toPasswordReset } from 'ducks/router'
import { useLoginForm } from './hooks'
import { EMAIL_FIELD, PASSWORD_FIELD } from './model'

import styles from './../Form.module.scss'

export const LoginForm = () => {
  const { authState } = useSelector(getUser)

  const { state, handlers } = useLoginForm()

  const { control, formState } = state
  const { handleFormSubmit } = handlers

  return (
    <>
      <h1 className={styles.title}>{t`Hi, and welcome!`}</h1>
      <MessageAlert
        className={styles.alert}
        message={t`The username or password entered was incorrect.`}
        size="medium"
        variant="error"
        isInitialised={formState.isSubmitSuccessful && authState === 'error'}
      />
      <Form className={styles.form} onSubmit={handleFormSubmit}>
        <Form.Field
          className={styles.field}
          error={formState.errors[EMAIL_FIELD]?.message}
          field="input"
          label={t`Email`}
          name={EMAIL_FIELD}
          type="email"
          {...{ control }}
        />
        <Form.Field
          className={styles.field}
          error={formState.errors[PASSWORD_FIELD]?.message}
          field="input"
          label={t`Password`}
          name={PASSWORD_FIELD}
          type="password"
          {...{ control }}
        />
        <Link
          className={styles.link}
          label={t`Forgot your password?`}
          size="small"
          variant="text"
          to={toPasswordReset()}
          redirect
        />
        <AuthButton
          className={styles.button}
          label={t`Log in`}
          type="submit"
          variant="filled"
        />
      </Form>
    </>
  )
}
